<template src="./template.html"></template>

<script>
// import moment from 'moment';

const currentYear = new Date().getFullYear()

export default {
  name: 'birthday-picker',
  props: {
    value: Object,
    pic: String,
    name: String,
  },
  computed: {},
  data() {
    return {
      birthdayForm: {
        birthdayDay: null,
        birthdayMonth: null,
        birthdayYear: null,
      },
      days: Array.from(Array(32).keys()).slice(1),
      months: [
        {
          key: 'Jan.',
          value: 1,
        },
        {
          key: 'Feb.',
          value: 2,
        },
        {
          key: 'Mar.',
          value: 3,
        },
        {
          key: 'Apr.',
          value: 4,
        },
        {
          key: 'May',
          value: 5,
        },
        {
          key: 'Jun.',
          value: 6,
        },
        {
          key: 'Jul.',
          value: 7,
        },
        {
          key: 'Aug.',
          value: 8,
        },
        {
          key: 'Sep.',
          value: 9,
        },
        {
          key: 'Oct.',
          value: 10,
        },
        {
          key: 'Nov.',
          value: 11,
        },
        {
          key: 'Dec.',
          value: 12,
        },
      ],
      years: Array.from(Array(currentYear + 1).keys())
        .slice(1920)
        .reverse(),
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.birthdayForm.birthdayDay = val.birthdayDay
        this.birthdayForm.birthdayMonth = val.birthdayMonth
        this.birthdayForm.birthdayYear = val.birthdayYear
      }
    },
  },
  methods: {
    onChange() {
      this.$emit('input', {
        birthdayDay: parseInt(this.birthdayForm.birthdayDay || 0, 10),
        birthdayMonth: parseInt(this.birthdayForm.birthdayMonth || 0, 10),
        birthdayYear: parseInt(this.birthdayForm.birthdayYear || 0, 10),
      })
    },
  },
  mounted() {
    if (this.value) {
      this.birthdayForm.birthdayDay = this.value.birthdayDay
      this.birthdayForm.birthdayMonth = this.value.birthdayMonth
      this.birthdayForm.birthdayYear = this.value.birthdayYear
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/BirthdayPicker/index.vue